export default __webpack_public_path__ + "static/media/main-bg.597e4bbc.png";